/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TPeopleCreateRequest } from "../../redux-modules/declarations/maps/people";
import apiClient from "../../utils/apiClient";

export const apiPeopleCreate = (
  data: TPeopleCreateRequest,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .post(API_ENDPOINTS.PEOPLE_LIST, data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
